// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorStatement_container__yfnxr","headline":"ErrorStatement_headline__Ju9IL","link":"ErrorStatement_link__tp_dV"};